export default "__VITE_ASSET__CXUDVh9b__"